import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Navbar from './components/Navbar/Navbar';
import AIChatbot from './components/AIChatbot';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DecoratorsPage from './pages/DecoratorsPage';
import DecoratorDetail from './pages/DecoratorDetail';
import BookingPage from './pages/BookingPage';
import ClientDashboard from './pages/ClientDashboard';
import DecoratorDashboard from './pages/DecoratorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import BookingDetail from './pages/BookingDetail';
import NotificationsPage from './pages/NotificationsPage';
import Chat from './pages/Chat';
import FAQ from "./pages/FAQ";
import PhotographersPage from './pages/PhotographersPage';
import EventPlannersPage from "./pages/EventPlannersPage"

// Routes mein add karo

import './App.css';

const PrivateRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/decorators" element={<DecoratorsPage />} />
        <Route path="/photographers" element={<PhotographersPage />} />
        <Route path="/photographers/:city" element={<PhotographersPage />} />
        <Route path="/decorators/:id" element={<DecoratorDetail />} />
        <Route path="/book/:decoratorId" element={<PrivateRoute roles={['client']}><BookingPage /></PrivateRoute>} />
        <Route path="/bookings/:id" element={<PrivateRoute><BookingDetail /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute roles={['client']}><ClientDashboard /></PrivateRoute>} />
        <Route path="/decorator/dashboard" element={<PrivateRoute roles={['decorator']}><DecoratorDashboard /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute roles={['admin']}><AdminDashboard /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><NotificationsPage /></PrivateRoute>} />
        <Route path="/chat" element={<PrivateRoute><Chat /></PrivateRoute>} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/event-planners" element={<EventPlannersPage />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {/* ✅ AI Chatbot — Admin ko nahi dikhega, baaki sab ko dikhega */}
      {user?.role !== 'admin' && <AIChatbot />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <SocketProvider>
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: { background: '#333', color: '#fff', borderRadius: '12px' },
              success: { style: { background: '#16a34a' } },
              error: { style: { background: '#dc2626' } },
            }}
          />
          <AppRoutes />
          <Analytics />
        </SocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;